import React from 'react';
import {
  Show, SimpleShowLayout, TextField, EmailField, DateField,
} from 'react-admin';

const SubscriberShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <EmailField source="email" />
      <TextField source="unsubscribe_key" />
      <DateField source="created_at" />
      <DateField source="updated_at" />
    </SimpleShowLayout>
  </Show>
);

export default SubscriberShow;
